import React, { useEffect, createElement } from 'react';
import { Navigation } from './components/Navigation';
import { FooterNav } from './components/FooterNav';
import { Hero } from './components/Hero';
import { ApproachTimeline } from './components/ApproachTimeline';
import { WhatsIncluded } from './components/WhatsIncluded';
import { PricingCard } from './components/PricingCard';
import { WeeklyTimeline } from './components/WeeklyTimeline';
import { TermsAccordion } from './components/TermsAccordion';
import { SignatureSection } from './components/SignatureSection';
import { ClientProvider, useClient } from './components/ClientContext';
import { WhatsAppWidget } from './components/WhatsAppWidget';
function AppContent() {
  const {
    companyName
  } = useClient();
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <div className="min-h-screen bg-offwhite selection:bg-accent/30 selection:text-white font-sans" data-id="element-0">
      <Navigation data-id="element-1" />
      <FooterNav data-id="element-2" />
      <WhatsAppWidget data-id="element-3" />

      <main className="pb-32" data-id="element-4">
        <Hero data-id="element-5" />
        <ApproachTimeline data-id="element-6" />
        <WhatsIncluded data-id="element-7" />
        <PricingCard data-id="element-8" />
        <WeeklyTimeline data-id="element-9" />
        <TermsAccordion data-id="element-10" />
        <SignatureSection data-id="element-11" />
      </main>

      <footer className="bg-[#050507] border-t border-white/[0.06] py-10 md:py-12 text-center text-sm md:text-base text-zinc-500 mb-20 px-4" data-id="element-12">
        <p data-id="element-13">&copy; 2026 AVY Consultancy Limited. All rights reserved.</p>
        <p className="mt-2" data-id="element-14">Proposal for {companyName}</p>
      </footer>
    </div>;
}
export function App() {
  return <ClientProvider data-id="element-15">
      <AppContent data-id="element-16" />
    </ClientProvider>;
}